import type { Chat, WebchatOrigin } from '../types/interfaces'

// `chats.channel_id`: por dónde se le escribe al cliente.
export const WHATSAPP_CHANNEL_ID = 'whatsapp'
export const WEBCHAT_CHANNEL_ID = 'webchat'

export const isWebchatChat = (chat?: Pick<Chat, 'channel_id'> | null): boolean =>
  chat?.channel_id === WEBCHAT_CHANNEL_ID

// Nombre, teléfono y correo ya tienen su lugar en el panel del contacto.
const ROLE_FIELD_KEYS = new Set(['name', 'phone', 'email'])

/** Lo que el agente ve del visitante de WebChat: lo que llenó en el formulario y desde dónde escribe. */
export const getWebchatVisitorDetails = (origin?: WebchatOrigin | null) => ({
  phone: origin?.visitor?.phone || null,
  email: origin?.visitor?.email || null,
  pageUrl: origin?.page_url || null,
  ip: origin?.ip || null,
  countryCode: origin?.country_code ? origin.country_code.toLowerCase() : null,
  countryName: origin?.country_name || null,
  fields: (origin?.visitor_fields ?? [])
    .filter((field) => !ROLE_FIELD_KEYS.has(field.key) && origin?.visitor?.[field.key])
    .map((field) => ({ ...field, value: origin?.visitor?.[field.key] ?? '' })),
})
